var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"pl-nav-content white",attrs:{"flat":"","light":"","app":"","fixed":""}},[_c('v-toolbar-title',[_vm._v("Ranges")]),_c('v-spacer'),_c('range-form')],1),_c('filter-nav'),_c('range-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }